﻿import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from "@angular/core";
import { DatePipe } from '@angular/common';
import { DataTable } from "angular2-datatable";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser"; 
import { DataService } from "../services/dataService";
import { Modal } from "../shared/dialog/dialog.component";
import { ModalService } from "../shared/dialog/dialog.service";
import { TextBoxComponent } from "../shared/Textbox/textBox.component";
import { ValidationBase } from "../validation/validationBase";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { ValidatorTuple } from "../validation/validators/iValidator";
import { PhoneValidator } from "../validation/validators/phoneValidator";
import { SearchCasesFilterPipe } from "../pipes/searchCases-filter.pipe";
import { Observable,of } from "rxjs";
import * as moment from 'moment';
import { Alert } from "../shared/modal/alert"

declare var $: any;

@Component({
    selector: "jax-createremovalrequestcomponent",
    templateUrl: "./createremovalrequest.component.html"
})

export class CreateRemovalRequestComponent extends ValidationBase{
    public iNotifyError;
    public data;
    public removalrequest: any = {};
    public childData: any = [];
    public parentRoles: any;
    public rowsOnPage = 10;
    public hasError = false;
    public errorMessage: string;
    public validationMessage: ValidationMessage;
    public countyValidationMessage: ValidationMessage;
    public isCompleted = false;
    public isSaveClicked = false;
    public isSubmitClicked = false;
    public currentUser: any;
    public counties: any = [];
    public JSON: any = JSON;
    public acceptedDate: string = "";
    public removalRequestNumber: string = "";
    public removalRequestId:number=-1;
    public requestStatus: string = "";
    public sub: any;
    private datePipe: DatePipe = new DatePipe('en-us');

    public phoneValidators = [];

    public probableCauseCheckError: boolean = false;
    public declarationCheckError: boolean = false;
    public employementCheckError: boolean = false;
    public otherQualificationError: boolean = false ;
    public factsError: boolean = false;
    public hasSuccess: boolean;

    public today = new Date().getTime();
    public minDate = new Date("1990-01-01").getTime();


    @ViewChild(Alert) alert: Alert;

    constructor(private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        private modalService: ModalService,
        private elementref: ElementRef, private sanitizer: DomSanitizer) {
        super();
        this.iNotifyError = this;
        this.phoneValidators.push(new ValidatorTuple(new PhoneValidator(), this));
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

        this.declarationCheckError = false;
        this.probableCauseCheckError=false;
        this.declarationCheckError=false;
        this.employementCheckError=false;
        this.otherQualificationError=false;
        this.factsError=false;
    }

    public initializeNewRequest() {
        this.currentUser.RemovalRequestID = -1;
        this.removalrequest.DCSCaseID = "";
        this.removalrequest.DCSUserID = this.currentUser.UserId;
        this.removalrequest.CreatedByUserID = this.currentUser.UserId;
        this.removalrequest.IsProbableCauseDeclarationAccepted = false;
        this.removalrequest.IsTruthDeclarationAccepted = false;
        this.removalrequest.IsEmployedByDCS = false;
        this.removalrequest.OtherQualification = "";
        this.removalrequest.DCSRequestReason = "";
        this.removalrequest.CallBackPhoneNumber = "";
        this.removalRequestNumber = "New";

        this.addChildRow();
        this.addChildRow();
        this.addChildRow();

        if (this.currentUser && this.currentUser.county) {
            this.removalrequest.county = this.counties.find(c => c.id === this.currentUser.county);
        } else {
            this.removalrequest.county = this.counties.find(c => c.id === 37180475);
        }
    }


    public getParentRoles() {
        let pr: any;
        this.dataService.get("RORequests/parentroles").subscribe(resp => {
                pr = resp;
               this.parentRoles= pr.map(p => {
                    return { Id: p.RemovalRequestParentRoleID, Name: p.Name };
                });
            },
            (error) => {
            });
    }

    public getRequest(requestId: number) {
        this.isCompleted = false;
        this.dataService.get("RORequests/removalrequest?Id=" + this.removalRequestId).subscribe(resp => {
                this.removalrequest = resp;
                if (this.removalrequest.CountyCodeID) {
                    this.removalrequest.county = this.counties.find(c => c.id === this.removalrequest.CountyCodeID);
            }
            if (this.removalrequest.RemovalRequestChilds) {
                this.removalrequest.RemovalRequestChilds.forEach((o, i) => {
                    o.DOB = this.datePipe.transform(o.DOB, 'yyyy-MM-dd');
                });
                this.childData = this.removalrequest.RemovalRequestChilds;
            } else {
                this.childData = [];
                this.addChildRow();
                this.addChildRow();
                this.addChildRow();
            }

                if (!this.removalrequest.RemovalRequestDisplayNumber) {
                    this.removalRequestNumber = "New";
                } else {
                    this.removalRequestNumber = this.removalrequest.RemovalRequestDisplayNumber;
                }

                
                if (this.removalrequest.TruthDeclarationAcceptedDate) {
                    this.acceptedDate = moment(this.removalrequest.TruthDeclarationAcceptedDate)
                        .format("MM/DD/YYYY hh:mm A");
                }
            this.isCompleted = true;



            },
            (error) => {
                this.isCompleted = true;
            });
    }

    public ngAfterViewInit() {
        $('input[type="text"][id$="dcsId"]').focus();
    }

    public ngOnInit() {
        this.isCompleted = true;
        this.GetCounties();
        this.getParentRoles();
        this.removalRequestNumber = "";
        this.isCompleted = true;
        this.sub = this.route.queryParams.subscribe(params => {
            this.removalRequestId = params["requestNumber"];
           // this.removalRequestId = 19;
            this.requestStatus = params["requestStatus"];
            if (!this.removalRequestId || this.removalRequestId<=0) {
                this.initializeNewRequest();
            } else {
                this.getRequest(this.removalRequestId);
            }
        });
        if (this.currentUser && this.currentUser.LastName) {
            this.removalrequest.DCSName = this.currentUser.LastName + ", " + this.currentUser.FirstName;
        }

   }

    public getChildRows():number {
        return this.childData.filter(c => c.IsDeleted === false).length;
    }

    public getParentRows(parents:any): number {
        return parents.filter(c => c.IsDeleted === false).length;
    }

    public addChildRow() {


        let childrow = {
            "id": this.childData.length,
            "FirstName": "",
            "LastName": "",
            "Sex": "",
            "DOB" : "",
            "ICWA": 0,
            "IsDeleted": false,
            "RemovalRequestID": this.removalrequest.RemovalRequestID,
            "RemovalRequestParent": [{ "RemovalRequestParentRoleID": 1, "Role": "1", "FirstName": "", "LastName": "", "IsDeleted": false },
                { "RemovalRequestParentRoleID": 2, "Role": "2", "FirstName": "", "LastName": "", "IsDeleted": false },
                { "RemovalRequestParentRoleID": 3, "Role": "3", "FirstName": "", "LastName": "", "IsDeleted": false }]
        };
        this.childData.push(childrow);
        this.removalrequest.RemovalRequestChilds = this.childData;
    }

    public removeChildRow(rowIndex: number) {
        let child = this.childData[rowIndex];
        if (child.RemovalRequestChildID > 0) {
            this.childData[rowIndex].IsDeleted = true;
            this.childData[rowIndex].RemovalRequestParent.forEach(p => p.IsDelete = true);
        } else {
            this.childData.splice(rowIndex, 1);    
        }
        
        this.removalrequest.RemovalRequestChilds = this.childData;
    }

    public addParent(rowIndex: number, pi: number) {
        let role: string = "";
        let parent = {
            "id": pi,
            "RemovalRequestParentRoleID": -1,
            "Role": "-1",
            "FirstName": "",
            "LastName": "",
            "IsDeleted": false
        };
        this.childData[rowIndex].RemovalRequestParent.push(parent);
        this.removalrequest.RemovalRequestChilds = this.childData;
    }

    public removeParent(rowIndex: number, mi: number) {
        let parent = this.childData[rowIndex].RemovalRequestParent[mi];
        if (parent.RemovalRequestParentID > 0) {
            this.childData[rowIndex].RemovalRequestParent[mi].IsDeleted=true;
        } else {
            this.childData[rowIndex].RemovalRequestParent.splice(mi, 1);    
        }
        
        this.removalrequest.RemovalRequestChilds = this.childData;
    }

    private GetCounties() {
        this.dataService.get("common/counties").subscribe(resp => {
            this.counties = resp;
            this.removalrequest.county = "";
            if (this.currentUser && this.currentUser.county) {
                this.removalrequest.county = this.counties.find(c => c.id === this.currentUser.county);
            } else {
                this.removalrequest.county = this.counties.find(c => c.id === 37180475);
            }
            this.removalrequest.CountyCodeID = this.removalrequest.county.id;
        });
    }

    public validateCounty($event: any): boolean {
        this.countyValidationMessage = null;
        this.removalrequest.county = this.counties.find(c => c.id === this.removalrequest.CountyCodeID);
        if (!this.removalrequest.county) {
            this.countyValidationMessage = this.getErrorMessage("County is required", "county");
            return false;
        }
        let selectedCounty = this.removalrequest.county.id || this.removalrequest.county;
        if (!this.counties.find(d => d.id == selectedCounty)) {
            this.countyValidationMessage = this.getErrorMessage("Invalid County", "county");
            this.removalrequest.county = null;
            return false;
        } else {
            this.removalrequest.CountyCodeID = selectedCounty;
        }

        return true;
    }

    public autocompleListFormatter = (data: any) => {
        let html = `<span>${data.value}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public validateRequets() {
        this.probableCauseCheckError = false;
        this.employementCheckError = false;
        this.declarationCheckError = false;
        this.factsError = false;
        this.hasError = false;
        this.validate()
            .subscribe((s) => {
                if (!this.removalrequest.IsProbableCauseDeclarationAccepted) {
                    this.probableCauseCheckError = true;
                }
                if (!this.removalrequest.IsEmployedByDCS) {
                    this.employementCheckError = true;
                }
                if (!this.removalrequest.IsTruthDeclarationAccepted) {
                    this.declarationCheckError = true;
                }

                if (this.removalrequest.DCSRequestReason === "") {
                    this.factsError = true;
                }

                this.validateGrid();
                if (this.removalrequest.isError) {
                    this.hasError = true;
                } else {
                }

                if (!this.isValid ||
                    this.probableCauseCheckError ||
                    this.employementCheckError ||
                    this.declarationCheckError ||
                    this.factsError ||
                    this.hasError) {
                    this.hasSuccess = false;
                    this.hasError = true;

                    setTimeout(() => {
                        let target;
                        target = $("div.has-error").first();
                        if (target && target.length > 0) {
                            let starget = $(target).find("input[type=text]").first();
                            if (!starget || starget.length == 0) {
                                starget = $(target).find("input[type=date]").first();
                            }

                            target = starget;
                        }
                        if (target && target.length > 0) {
                            let top = $(target).offset().top;
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                if (window.scrollY) {
                                    window.scroll(0, 0); // reset the scroll position to the top left of the document.
                                    target.focus();
                                } else {
                                    //    $("html,body").animate({ scrollTo: top },
                                    //        "slow",
                                    //        () => {
                                    //            target.focus();
                                    //        });
                                    //}
                                    window.scroll(0, 0); // reset the scroll position to the top left of the document.
                                    target.focus();
                                }
                            } else {
                                $("html,body").animate({ scrollTop: top }, "slow", () => {
                                    target.focus();
                                });    
                            }

                            
                        }
                    }, 50);

                 
                    return;
                } else {
                    this.hasSuccess = true;
                    this.removeValidatedChild();
                }
            });
    }

    private removeValidatedChild() {
        let ci: number;
        let pi: number;
        for (ci = this.removalrequest.RemovalRequestChilds.length - 1; ci >= 0; ci -= 1) {
            let child = this.removalrequest.RemovalRequestChilds[ci];
            if (!child.isError && child.ErrorMessage === "NotFilled") {
                this.removeChildRow(ci);
            } else {

                for (pi = child.RemovalRequestParent.length - 1; pi >= 0; pi -= 1) {
                    let parent = child.RemovalRequestParent[pi];
                    if (!parent.isError && parent.ErrorMessage === "NotFilled") {
                        this.removeParent(ci, pi);
                    }
                }
            }
        }
    }

    public isParentsEnterd(item) :boolean{
        let isError: boolean = false;
        let isNameValidForOneParent: boolean = false;
        item.forEach((obj, index) => {
            if (obj.FirstName !== "" && obj.LastName !== "" ) {
                isNameValidForOneParent = true;
            } 
            if (obj.FirstName === "" && obj.LastName === "" && !isNameValidForOneParent) {
                isError = true;
            } 
            if (obj.FirstName !== "" && obj.LastName === "") {
                isError = true;
            }
            if (obj.FirstName === "" && obj.LastName !== "") {
                isError = true;
            }
        });

        return isError;
    }


    public openPdf() {
        this.dataService.sharedService.openPopupWindow();
        if (this.removalrequest.RemovalRequestID > 0) {
            this.dataService.getPdf("rorequests/RRRequestPdf?removalRequestID=" +
                    this.removalrequest.RemovalRequestID +
                    "&isPrintOrder=false&isPreview=true")
                .subscribe((res) => {
                    this.dataService.sharedService.displayPdf(res,"request.pdf");
                },
                (error) => {
                    this.dataService.sharedService.closePopupWindow();
                });
        }
    }
    public printPreview() {
        this.saveRequest(false, true);
    }

    public saveRequest(isSubmit : boolean, isPreview=false):any  {
        this.isCompleted = false;
        this.hasError = false;
        this.isSaveClicked = true;
        this.phoneFormat();

        if (!this.removalrequest.CountyCodeID) {
            let selectedCounty = this.removalrequest.county.id || this.removalrequest.county;
            this.removalrequest.CountyCodeID = selectedCounty;
        }

        if (!isSubmit) {
            this.validateGrid();
            if (!this.removalrequest.isError) {
                this.removeValidatedChild();
            } else {
                this.isCompleted = true;
                this.hasError = true;
                return;
            }
        }

        this.dataService.post("RORequests/submitremovalrequest", JSON.stringify(this.removalrequest)).subscribe(
            (response) => {
                this.errorMessage = "";
                this.removalrequest = response;
                this.removalrequest.county = this.counties.find(c => c.id === this.removalrequest.CountyCodeID);
                this.isCompleted = true;
                if (isSubmit) {
                    this.confirmClose("");
                } else {
                    if (isPreview) {
                        this.openPdf();
                    }
                    if (this.removalrequest.RemovalRequestChilds) {
                        this.removalrequest.RemovalRequestChilds.forEach((o, i) => {
                            o.DOB = this.datePipe.transform(o.DOB, 'yyyy-MM-dd');
                        });
                        this.childData = this.removalrequest.RemovalRequestChilds;
                    }
                }
                return this.removalrequest.RemovalRequestID;
            },
            (error) => {
                this.errorMessage = error.message;
                this.hasError = true;
                this.isCompleted = true;
                return -1;
            });
}

    public submitRequest() {
        this.isCompleted = false;
        this.isSubmitClicked = true;
        this.validateRequets();
        if (this.hasSuccess) {
            this.removalrequest.IsSubmit = true;
            this.saveRequest(true);
        } else {
            this.isCompleted = true;    
        }
    }

    public confirmOpen() {
        this.alert.cancelButton = true;
        this.alert.okButton = true;
        this.alert.alertTitle = "Confirm?";
        this.alert.message = "The unsaved changes will be lost, Are you sure you want to exit?";
        this.alert.okButtonText = "Yes";
        this.alert.okButtonType = "btn-danger";
        this.alert.cancelButtonText = "No";
        this.alert.open();
    }

    public confirmClose(event) {
        let e = event;

        setTimeout(()=> {
            this.router.navigate(["../removalrequest"], { relativeTo: this.route });
        }, 1000);
    } 
            
    public validateComments() {
        
    }

    public validateAdditionalInformation() {
        
    }

    public getAcceptedDate(e) {
        let todaysDate = new Date();
        if (e.target.checked) {
            this.acceptedDate = moment(todaysDate).format("MM/DD/YYYY hh:mm A");
            this.removalrequest.TruthDeclarationAcceptedDate = this.acceptedDate;
        } else {
            this.acceptedDate = "";
            this.removalrequest.TruthDeclarationAcceptedDate = "";
        }        
    }

    private phoneFormat() {
        if (this.removalrequest.CallBackPhoneNumber) {
            if (!isNaN(this.removalrequest.CallBackPhoneNumber)) {
                this.removalrequest.CallBackPhoneNumber = this.removalrequest.CallBackPhoneNumber.substring(0, 3) + "-" + this.removalrequest.CallBackPhoneNumber.substring(3, 6) + "-" + this.removalrequest.CallBackPhoneNumber.substring(6, 10);
            }
            else {
                this.removalrequest.CallBackPhoneNumber = this.removalrequest.CallBackPhoneNumber.replace(")-", ") ");
            }
        }
    }

    private getErrorMessage(message: string, propName: string): ValidationMessage {
        let vm = new ValidationMessage();
        vm.message = message;
        vm.propertyName = propName;
        vm.messageType = ValidationMessageType.Error;
        return vm;
    }


    private validateChild(child, index): void {
        if (child.IsDeleted) {
            return;
        }

        let orFlag; // indicates atleast one field is populated
        let andFlag; // indicated all fields are populated

        // Reset validations
        child.isError = false;
        child.ErrorMessage = "";

        orFlag = child.FirstName || child.LastName || child.DOB || child.Sex;
        andFlag = child.FirstName && child.LastName && child.DOB && child.Sex;

        if (!child.RemovalRequestParent.length) {
            if (orFlag) {
                child.isError = true;
                child.ErrorMessage = "Parents missing";
                return;
            }
        }

        let perfectParent = child.RemovalRequestParent.findIndex(parent => {
            return parent.FirstName && parent.LastName;
        }) >= 0;

        child.RemovalRequestParent.forEach(parent => {
            parent.isError = false;
            parent.ErrorMessage = "";

            orFlag = orFlag || parent.FirstName || parent.LastName;

            // if there is no other parent with perfect stat and
            // any of the fields are populated than update andFlag
            if (!perfectParent || parent.FirstName || parent.LastName ) {
                andFlag = andFlag && parent.FirstName && parent.LastName;
            }

        });

        if (andFlag) {
            if (!Date.parse(child.DOB) ||
                new Date(child.DOB).getTime() < this.minDate ||
                new Date(child.DOB).getTime() > this.today) {
                child.isError = true;
                child.ErrorMessage = "Invalid Date"; 
            }
            // No error
        } else if (!andFlag && orFlag) {
            child.isError = true;
            child.ErrorMessage = "Required";
        } else {
            // else all are blank fields
            if (index == -1) {
                if (!child.RemovalRequestParent.length) {
                    child.isError = true;
                    child.ErrorMessage = "Parents missing";
                    return;
                } else {
                    child.isError = true;
                    child.ErrorMessage = "Required";
                }
            } else {
                child.isError = false;
                child.ErrorMessage = "NotFilled";
            }
        }

        child.RemovalRequestParent.forEach(parent => {

            // If atleast one is filled
            if (parent.FirstName || parent.LastName) {
                // but not all are filled
                if (parent.FirstName || !parent.FirstName ) {
                    parent.isError = true;
                    parent.ErrorMessage = "Required";
                }
            } else { // all fields in this parent are empty

                // if atleast one field in this child object is filled
                if (orFlag) {
                    // if there is other parent with correct stat
                    if (perfectParent) {
                        parent.isError = false;
                        parent.ErrorMessage = "NotFilled";
                    } else {
                        parent.isError = true;
                        parent.ErrorMessage = "Required";
                    }
                } else { // if all fields in this child are empty

                    if (index == -1) {
                        parent.isError = true;
                        parent.ErrorMessage = "Required";
                    } else {
                        parent.isError = false;
                        parent.ErrorMessage = "NotFilled";
                    }

                }
            }

        });
    }

    private validateGrid(): void {

        // reset validations
        this.removalrequest.isError = false;
        this.removalrequest.ErrorMessage = "";

        if (!this.childData.length) {
            this.removalrequest.isError = true;
            this.removalrequest.ErrorMessage = "child missing";
            return;
        }

        // correct child index
        let _index = -1;

        this.childData.forEach((child, index) => {
            this.validateChild(child, -1);
            // update correct child index
            if (!child.isError) {
                _index = index;
            }
        });

        // revalidate error messages
        this.childData.forEach(child => {
            this.validateChild(child, _index);
        });


        let flag = false; // to handle missing parent error

        // To update Request object error message
        this.removalrequest.RemovalRequestChilds.forEach((child) => {
            this.removalrequest.isError = this.removalrequest.isError || (child.isError && child.ErrorMessage != "NotFilled");
            flag = flag || (child.isError && !child.RemovalRequestParent.length);
        });

        if (flag) {
            this.removalrequest.isError = true;
            this.removalrequest.ErrorMessage = "parents not entered";
        } else if (this.removalrequest.isError) {
            this.removalrequest.ErrorMessage = "Required";
            this.removalrequest.isError = true;
        }
    }

    public textToProperCase(event) {
        let i = event.indexOf("-");
        let ip = event.indexOf(".");

        if (i >= 0) {
            event = event.replace("-", " ");
        }

        if (ip >= 0) {
            event = event.replace(".", " ");
        }


        let properString = event.length > 0 ? event.replace(/\w\S*/g, (txt =>  this.convertToProperCase(txt))) : "";
        if (i > 0) {
            properString = properString.substr(0, i) + properString.substr(i).replace(" ", "-");
        }

        if (ip > 0) {
            properString = properString.substr(0, ip) + properString.substr(ip).replace(" ", ".");
        }

        return properString;
    }

    public convertToProperCase(str: string): string {

        let romannumeral = str.toLowerCase().match(/m|d|c|l|x|v|i/ig);
        if (romannumeral) {
            if (str.length == romannumeral.length) {
                return str;
            }
        } 

        let convertedStr = str[0].toUpperCase() + str.substr(1).toLowerCase();

        return convertedStr;
    }

}